import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import logo from "@/assets/logo-transparent.png";
import CrisisBanner from "@/components/CrisisBanner";

const CONSENT_KEY = "hwhc_cookie_consent";

const Footer = () => {
  const resetCookiePreferences = () => {
    localStorage.removeItem(CONSENT_KEY);
    window.location.reload();
  };

  return (
    <footer className="border-t border-border/30 bg-foreground text-primary-foreground">
      <div className="container grid gap-10 py-16 md:grid-cols-5">
        <div>
          <div className="flex items-center gap-2.5">
            <img src={logo} alt="HWHC" className="h-[50px] w-[50px] object-contain" />
            <span className="font-display text-lg font-semibold leading-tight">Hope & Wellness<br />Healing Center</span>
          </div>
          <p className="mt-4 text-sm text-primary-foreground/85">
            Compassionate, evidence-based psychotherapy and counseling for individuals and families.
          </p>
          
        </div>
        <div>
          <h3 className="mb-4 text-xs font-semibold uppercase tracking-widest text-primary-foreground/85">Services</h3>
          <ul className="space-y-2.5 text-sm text-primary-foreground/90">
            <li><Link to="/services" className="hover:text-primary-foreground transition-colors">Therapy Services</Link></li>
            <li><Link to="/for-practitioners" className="hover:text-primary-foreground transition-colors">For Practitioners</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="mb-4 text-xs font-semibold uppercase tracking-widest text-primary-foreground/85">Resources</h3>
          <ul className="space-y-2.5 text-sm text-primary-foreground/90">
            <li><Link to="/resources" className="hover:text-primary-foreground transition-colors">Blog</Link></li>
            <li><Link to="/events" className="hover:text-primary-foreground transition-colors">Event Calendar</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="mb-4 text-xs font-semibold uppercase tracking-widest text-primary-foreground/85">Contact</h3>
          <ul className="space-y-2.5 text-sm text-primary-foreground/90">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-primary-foreground/85" /> info@hwhctherapy.com</li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary-foreground/85" /> Canton, Baltimore, MD</li>
          </ul>
        </div>
      </div>
      <div className="container pb-4 pt-2">
        <CrisisBanner variant="dark" />
      </div>
      <div className="border-t border-primary-foreground/20 py-5 text-center text-xs text-primary-foreground/85">
        <div className="mb-3 flex items-center justify-center gap-2 flex-wrap">
          <span className="inline-flex items-center rounded-full border border-primary-foreground/20 bg-primary-foreground/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary-foreground/80">
            Veteran-Owned
          </span>
          <span className="inline-flex items-center rounded-full border border-primary-foreground/20 bg-primary-foreground/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary-foreground/80">
            Black-Owned
          </span>
        </div>

        <p className="mb-2 text-[11px] text-primary-foreground/80">
          hwhctherapy.com does not collect patient health information. Client services are managed through SimplePractice.
        </p>
        <p>© {new Date().getFullYear()} Hope & Wellness Healing Center. All rights reserved.</p>
        <div className="mt-1 flex items-center justify-center gap-3">
          <Link to="/privacy-policy" className="text-primary-foreground/80 underline underline-offset-2 hover:text-primary-foreground transition-colors">Privacy Policy</Link>
          <span className="text-primary-foreground/60">·</span>
          <Link to="/terms" className="text-primary-foreground/80 underline underline-offset-2 hover:text-primary-foreground transition-colors">Terms of Use</Link>
          <span className="text-primary-foreground/60">·</span>
          <button onClick={resetCookiePreferences} className="text-primary-foreground/80 underline underline-offset-2 hover:text-primary-foreground transition-colors">Cookie Preferences</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
